<div class="help-center">
  <div class="help-center__topbar" *ngIf="currentView !== 'home'">
    <button nz-button nzType="default" nzSize="small" (click)="goHome()">
      <span nz-icon nzType="arrow-left"></span>
      {{ 'HELP.BACK' | translate }}
    </button>
  </div>

  <ng-container [ngSwitch]="currentView">
    <section *ngSwitchCase="'home'" class="help-center__home">
      <div class="help-center__hero">
        <div class="help-center__hero-copy">
          <h2>{{ 'HELP.HOME.TITLE' | translate }}</h2>
          <p>{{ 'HELP.HOME.DESCRIPTION' | translate }}</p>
        </div>
        <div class="help-center__hero-search">
          <div class="help-center__hero-search-controls">
            <input
              nz-input
              class="help-center__hero-search-input"
              [ngModel]="searchQuery"
              (ngModelChange)="searchQuery = $event"
              [placeholder]="'HELP.HOME.SEARCH_PLACEHOLDER' | translate"
            />
            <button nz-button nzType="primary" class="help-center__hero-search-button" (click)="openSearchFromHome()">
              <span nz-icon nzType="search"></span>
              {{ 'HELP.HOME.SEARCH_CTA' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="help-center__actions" data-tour="help-center-actions">
        <button nz-button nzType="primary" class="help-center__action-card" (click)="productTourRequested.emit()">
          <span nz-icon nzType="compass"></span>
          <strong>{{ 'TOUR.HELP.START_PRODUCT_TOUR' | translate }}</strong>
          <span>{{ 'TOUR.HELP.START_PRODUCT_TOUR_DESCRIPTION' | translate }}</span>
        </button>
        <button nz-button nzType="default" class="help-center__action-card" (click)="navigate('browse-docs')">
          <span nz-icon nzType="book"></span>
          <strong>{{ 'HELP.HOME.BROWSE_TITLE' | translate }}</strong>
          <span>{{ 'HELP.HOME.BROWSE_DESC' | translate }}</span>
        </button>
        <button
          nz-button
          nzType="default"
          class="help-center__action-card"
          (click)="openDemoBooking($event)"
        >
          <span nz-icon nzType="calendar"></span>
          <strong>{{ 'HELP.HOME.DEMO_TITLE' | translate }}</strong>
          <span>{{ 'HELP.HOME.DEMO_DESC' | translate }}</span>
        </button>
        <button nz-button nzType="default" class="help-center__action-card" (click)="navigate('ask-ai')">
          <span nz-icon nzType="robot"></span>
          <strong>{{ 'HELP.HOME.ASK_AI_TITLE' | translate }}</strong>
          <span>{{ 'HELP.HOME.ASK_AI_DESC' | translate }}</span>
        </button>
        <button nz-button nzType="default" class="help-center__action-card" (click)="navigate('contact-support')">
          <span nz-icon nzType="mail"></span>
          <strong>{{ 'HELP.HOME.SUPPORT_TITLE' | translate }}</strong>
          <span>{{ 'HELP.HOME.SUPPORT_DESC' | translate }}</span>
        </button>
        <button nz-button nzType="default" class="help-center__action-card" (click)="navigate('report-bug')">
          <span nz-icon nzType="bug"></span>
          <strong>{{ 'HELP.HOME.BUG_TITLE' | translate }}</strong>
          <span>{{ 'HELP.HOME.BUG_DESC' | translate }}</span>
        </button>
        <button nz-button nzType="default" class="help-center__action-card" (click)="navigate('feature-request')">
          <span nz-icon nzType="star"></span>
          <strong>{{ 'HELP.HOME.FEATURE_TITLE' | translate }}</strong>
          <span>{{ 'HELP.HOME.FEATURE_DESC' | translate }}</span>
        </button>
      </div>
    </section>

    <section *ngSwitchCase="'search'" class="help-center__section">
      <h2>{{ 'HELP.SEARCH.TITLE' | translate }}</h2>
      <p>{{ 'HELP.SEARCH.DESCRIPTION' | translate }}</p>
      <input
        nz-input
        [ngModel]="searchQuery"
        (ngModelChange)="onSearchChange($event)"
        [placeholder]="'HELP.SEARCH.PLACEHOLDER' | translate"
      />

      <div class="help-center__results" *ngIf="searchResults.length">
        <button
          *ngFor="let result of searchResults"
          nz-button
          nzType="default"
          class="help-center__result"
          (click)="openArticle(result.slug)"
        >
          <strong>{{ result.title }}</strong>
          <span>{{ result.section }}<ng-container *ngIf="result.subsection"> / {{ result.subsection }}</ng-container></span>
        </button>
      </div>

      <nz-empty
        *ngIf="searchTouched && !searching && !searchResults.length"
        [nzNotFoundContent]="'HELP.SEARCH.EMPTY' | translate"
      ></nz-empty>
    </section>

    <section *ngSwitchCase="'browse-docs'" class="help-center__section">
      <h2>{{ 'HELP.BROWSE.TITLE' | translate }}</h2>
      <p>{{ 'HELP.BROWSE.DESCRIPTION' | translate }}</p>

      <nz-collapse nzBordered *ngIf="groupedSections.length">
        <nz-collapse-panel
          *ngFor="let section of groupedSections"
          [nzHeader]="section.key"
          [nzShowArrow]="true"
        >
          <div *ngFor="let subsection of section.subsections" class="help-center__subsection">
            <p class="help-center__subsection-title" *ngIf="subsection.key">{{ subsection.key }}</p>
            <button
              *ngFor="let article of subsection.articles"
              nz-button
              nzType="link"
              class="help-center__article-link"
              (click)="openArticle(article.slug)"
            >
              {{ article.title }}
            </button>
          </div>
        </nz-collapse-panel>
      </nz-collapse>

      <nz-empty *ngIf="!loadingBrowse && !groupedSections.length" [nzNotFoundContent]="'HELP.BROWSE.EMPTY' | translate"></nz-empty>
    </section>

    <section *ngSwitchCase="'ask-ai'" class="help-center__section">
      <h2>{{ 'HELP.AI.TITLE' | translate }}</h2>
      <p>{{ 'HELP.AI.DESCRIPTION' | translate }}</p>
      <app-ask-ai
        (interactionChange)="handleAiStateChange($event)"
        (escalate)="handleAiEscalation($event)"
      ></app-ask-ai>
    </section>

    <section *ngSwitchCase="'contact-support'" class="help-center__section">
      <h2>{{ 'HELP.FORMS.SUPPORT_TITLE' | translate }}</h2>
      <p>{{ 'HELP.FORMS.SUPPORT_DESCRIPTION' | translate }}</p>
      <form nz-form [formGroup]="supportForm" (ngSubmit)="submitSupport()">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.SUBJECT' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input formControlName="subject" [placeholder]="'HELP.FORMS.SUPPORT_SUBJECT_PLACEHOLDER' | translate" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.MESSAGE' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="5" formControlName="message" [placeholder]="'HELP.FORMS.SUPPORT_MESSAGE_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <button nz-button nzType="primary" [nzLoading]="submittingSupport" [disabled]="submittingSupport || supportForm.invalid">
          {{ 'HELP.FORMS.SUBMIT_SUPPORT' | translate }}
        </button>
      </form>
    </section>

    <section *ngSwitchCase="'report-bug'" class="help-center__section">
      <h2>{{ 'HELP.FORMS.BUG_TITLE' | translate }}</h2>
      <p>{{ 'HELP.FORMS.BUG_DESCRIPTION' | translate }}</p>
      <form nz-form [formGroup]="bugForm" (ngSubmit)="submitBug()">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.SUBJECT' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input formControlName="subject" [placeholder]="'HELP.FORMS.BUG_SUBJECT_PLACEHOLDER' | translate" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.WHAT_HAPPENED' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="4" formControlName="whatHappened" [placeholder]="'HELP.FORMS.WHAT_HAPPENED_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.EXPECTED_BEHAVIOR' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="4" formControlName="expectedBehavior" [placeholder]="'HELP.FORMS.EXPECTED_BEHAVIOR_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.STEPS' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="5" formControlName="stepsToReproduce" [placeholder]="'HELP.FORMS.STEPS_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.SEVERITY' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select formControlName="severity">
              <nz-option nzValue="low" [nzLabel]="'HELP.FORMS.SEVERITY_LOW' | translate"></nz-option>
              <nz-option nzValue="medium" [nzLabel]="'HELP.FORMS.SEVERITY_MEDIUM' | translate"></nz-option>
              <nz-option nzValue="high" [nzLabel]="'HELP.FORMS.SEVERITY_HIGH' | translate"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <button nz-button nzType="primary" [nzLoading]="submittingBug" [disabled]="submittingBug || bugForm.invalid">
          {{ 'HELP.FORMS.SUBMIT_BUG' | translate }}
        </button>
      </form>
    </section>

    <section *ngSwitchCase="'feature-request'" class="help-center__section">
      <h2>{{ 'HELP.FORMS.FEATURE_TITLE' | translate }}</h2>
      <p>{{ 'HELP.FORMS.FEATURE_DESCRIPTION' | translate }}</p>
      <form nz-form [formGroup]="featureForm" (ngSubmit)="submitFeature()">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.SUBJECT' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input formControlName="subject" [placeholder]="'HELP.FORMS.FEATURE_SUBJECT_PLACEHOLDER' | translate" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.TRYING_TO_DO' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="4" formControlName="tryingToDo" [placeholder]="'HELP.FORMS.TRYING_TO_DO_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.MISSING_FEATURE' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="4" formControlName="missingFeature" [placeholder]="'HELP.FORMS.MISSING_FEATURE_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ 'HELP.FORMS.IMPACT' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="4" formControlName="impact" [placeholder]="'HELP.FORMS.IMPACT_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">{{ 'HELP.FORMS.WORKAROUND' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea nz-input rows="3" formControlName="workaround" [placeholder]="'HELP.FORMS.WORKAROUND_PLACEHOLDER' | translate"></textarea>
          </nz-form-control>
        </nz-form-item>
        <button nz-button nzType="primary" [nzLoading]="submittingFeature" [disabled]="submittingFeature || featureForm.invalid">
          {{ 'HELP.FORMS.SUBMIT_FEATURE' | translate }}
        </button>
      </form>
    </section>
  </ng-container>
</div>
